// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"23661": "ab2be212aeef","42530": "81999d02ec3f","45803": "472298848fa6","65336": "ea808a117b2e","66863": "c939bdd77392","72653": "f8b6bd260d93",}[chunkId] + ".css"
}